import axios from 'axios';

// Usa REACT_APP_API_BASE_URL come sorgente principale; mantiene compatibilità con REACT_APP_API_URL.
const API_URL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  'http://127.0.0.1:8000/api';

// Normalizza 0.0.0.0 -> localhost per evitare problemi di cookie/sessione
const NORMALIZED_API_URL = API_URL.replace('0.0.0.0', 'localhost');

// Configurazione di axios con token JWT
const api = axios.create({
  baseURL: NORMALIZED_API_URL,
});

// Interceptor per aggiungere il token di autenticazione alle richieste
api.interceptors.request.use(
  (config) => {
    // Permette di inviare richieste pubbliche senza header Authorization
    if (config.skipAuth) {
      return config;
    }
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Servizi di autenticazione
export const authService = {
  login: (email, password, recaptchaToken) => api.post('/login/', { email, password, recaptcha_token: recaptchaToken }, { skipAuth: true }),
  refreshToken: (refreshToken) => api.post('/token/refresh/', { refresh: refreshToken }, { skipAuth: true }),
  register: (userData, recaptchaToken) => api.post('/registration-requests/', { ...userData, recaptcha_token: recaptchaToken }, { skipAuth: true }),
  getProfile: () => api.get('/users/me/'),
  changePassword: (oldPassword, newPassword) => api.post('/users/change_password/', { old_password: oldPassword, new_password: newPassword }),
  forgotPassword: (email) => api.post('/users/forgot_password/', { email }, { skipAuth: true }),
};

// Servizi per le richieste di registrazione (per admin e moderatori)
export const registrationRequestService = {
  getRequests: () => api.get('/registration-requests/'),
  approveRequest: (id) => api.post(`/registration-requests/${id}/approve/`),
  rejectRequest: (id) => api.post(`/registration-requests/${id}/reject/`),
};

// Servizi per la gestione degli utenti (per admin)
export const userService = {
  getUsers: () => api.get('/users/'),
  getChoices: () => api.get('/users/choices/'),
  getDirectory: (lang) => api.get('/users/directory/', lang ? { params: { lang } } : undefined),
  getUser: (id) => api.get(`/users/${id}/`),
  createUser: (userData) => api.post('/users/', userData),
  updateUser: (id, userData) => api.patch(`/users/${id}/`, userData),
  deleteUser: (id) => api.delete(`/users/${id}/`),
  resetPassword: (id) => api.post(`/users/${id}/reset_password/`),
};

// Servizi per categorie e sottocategorie
export const categoryService = {
  list: (lang) => api.get('/categories/', lang ? { params: { lang } } : undefined),
  create: (data) => api.post('/categories/', data),
  update: (id, data) => api.patch(`/categories/${id}/`, data),
  delete: (id) => api.delete(`/categories/${id}/`),
};

export const subCategoryService = {
  list: (lang) => api.get('/subcategories/', lang ? { params: { lang } } : undefined),
  create: (data) => api.post('/subcategories/', data),
  update: (id, data) => api.patch(`/subcategories/${id}/`, data),
  delete: (id) => api.delete(`/subcategories/${id}/`),
};

// Servizi per le abilità utente
export const skillService = {
  // Utente autenticato vede le proprie abilità; admin/mod possono passare ?user=<id>
  list: (params) => api.get('/skills/', params ? { params } : undefined),
  create: (data) => api.post('/skills/', data),
  update: (id, data) => api.patch(`/skills/${id}/`, data),
  delete: (id) => api.delete(`/skills/${id}/`),
};

// Servizi ledger: conto ore e transazioni
export const ledgerService = {
  getAccount: () => api.get('/account/'),
  getAllAccounts: () => api.get('/account/all/'),
  getAccountForUser: (userId) => api.get('/account/user/', { params: { user: userId } }),
  listTransactions: (params) => api.get('/transactions/', params ? { params } : undefined),
  createTransaction: (data) => api.post('/transactions/', data),
  approveTransaction: (id) => api.post(`/transactions/${id}/approve/`),
  rejectTransaction: (id) => api.post(`/transactions/${id}/reject/`),
};

// Servizi per le richieste di scambio
export const exchangeService = {
  // Tutte le richieste (solo admin/moderator/superadmin)
  list: (params) => api.get('/exchange-requests/', params ? { params } : undefined),
  // Le mie richieste (inviate e ricevute)
  my: (params) => api.get('/exchange-requests/my/', params ? { params } : undefined),
  create: (data) => api.post('/exchange-requests/', data),
  update: (id, data) => api.patch(`/exchange-requests/${id}/`, data),
  respond: (id, status) => api.post(`/exchange-requests/${id}/respond/`, { status }),
  delete: (id) => api.delete(`/exchange-requests/${id}/`),
};

export default api;
